import {Box, Flex, Menu, MenuButton, Text} from '@chakra-ui/react';
import {useCartContext} from 'components/providers';
import {AlertDialog} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC, useState} from 'react';
import NextImageUI from 'ui/NextImage';

import {NotificationsBell} from '../notifications-bell';
import {CartMenu} from './components';

export const Cart: FC = () => {
  const {t} = useTranslation();
  const {cartItems, requiredProducts, clearCart, sideCartOpen, setSideCartOpen, cartProvider} = useCartContext();

  const [isOpenAlert, setIsOpenAlert] = useState(false);

  const countItemProduct = cartItems.reduce((sum, currentItem) => {
    if (cartProvider?.slug === 'metro') {
      return sum + (currentItem.product.is_weighted_product ? 1 : Number(currentItem.quantity));
    }
    return sum + Number(currentItem.quantity);
  }, 0);

  const countCartWithRequiredProducts = countItemProduct + requiredProducts.length;
  const count = !!requiredProducts.length ? countCartWithRequiredProducts : countItemProduct;

  const onToggleOpenAlert = () => {
    setIsOpenAlert((prev) => !prev);
  };

  return (
    <>
      <Menu isLazy direction="ltr">
        <>
          <MenuButton disabled={count === 0} onClick={() => setSideCartOpen(true)}>
            <Box justifyItems="center">
              <Flex alignItems="center">
                <Flex position="relative">
                  <Flex opacity={!count ? 0.5 : 1}>
                    <NextImageUI width={25} height={25} src="/basket-icon.svg" />
                  </Flex>
                  {count > 0 && <NotificationsBell count={count} />}
                </Flex>
              </Flex>
              <Text fontSize="12px" textAlign="center">
                {t('CART')}
              </Text>
            </Box>
          </MenuButton>
          <CartMenu isOpen={sideCartOpen} onClose={() => setSideCartOpen(false)} onOpenAlert={onToggleOpenAlert} />
        </>
      </Menu>
      <AlertDialog // AlertDialog must be outside the menu field
        title={t('CLEAR_CART_TITLE')}
        onClose={onToggleOpenAlert}
        isOpen={isOpenAlert}
        onConfirm={clearCart}
      >
        {t('CLEAR_CART_DESCRIPTION')}
      </AlertDialog>
    </>
  );
};
